<template>
    <div>
        <b-row>
            <b-col v-if="item && item.listing">
                <b-row>
                    <b-col sm="6">
                        <images-zoom v-if="item.listing.images" :images="item.listing.images"></images-zoom>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col>
                        <p class="mt-3 mb-0">{{ buildArtist(item) }}: {{ buildFullTitle(item) }} {{ buildMedia(item) }}</p>
                        <p class="mb-0">{{ buildLabelName(item) }} {{ buildLabelNo(item) }}</p>
                        <p class="mb-0"><em>{{ buildAttributes(item) }}</em></p>
                        <p class="mb-0">Item #{{ item.itemId }} | {{ buildCondition(item).join(', ') }} | ${{ item.listing.price }}</p>
                    </b-col>
                </b-row>
            </b-col>
        </b-row>
    </div>
</template>

<script>
    import ImagesZoom from "./ImagesZoom";
    import itemMixin from "../../mixins/item";
    import utils from "../../mixins/utils";

    export default {
        name: "ItemOverview",
        props: [ 'item' ],
        mixins: [ itemMixin, utils ],
        components: { ImagesZoom },
    }
</script>

<style scoped>

</style>